{
  "performance.title": "Performance",
  "performance.period": "{start} – {end}",
  "performance.people.search": "Search people",
  "performance.people.empty": "No one matches that search.",
  "performance.noAccess.title": "Performance is managed by HR",
  "performance.noAccess.body": "Running review cycles, calibration and templates needs the “Manage performance” permission. Ask an admin if you need it.",
  "performance.notAvailable.title": "This isn’t available",
  "performance.notAvailable.body": "It doesn’t exist, or it isn’t shared with you.",
  "performance.autosave.saving": "Saving…",
  "performance.autosave.saved": "Saved",
  "performance.autosave.failed": "Not saved",
  "performance.rating.1": "Needs improvement",
  "performance.rating.2": "Developing",
  "performance.rating.3": "Meets expectations",
  "performance.rating.4": "Exceeds expectations",
  "performance.rating.5": "Outstanding",
  "performance.rating.option": "{number} – {label}",
  "performance.rating.outOf": "{number} out of {total}",
  "performance.rating.none": "Not rated yet",
  "performance.cycle.status.draft": "Draft",
  "performance.cycle.status.active": "Active",
  "performance.cycle.status.calibration": "Calibration",
  "performance.cycle.status.published": "Published",
  "performance.cycle.status.closed": "Closed",
  "performance.review.status.pending": "Pending",
  "performance.review.status.submitted": "Submitted",
  "performance.review.status.declined": "Declined",
  "performance.review.kind.self": "Self review",
  "performance.review.kind.manager": "Manager review",
  "performance.review.kind.peer": "Peer review",
  "performance.review.kind.upward": "Upward review",
  "performance.review.kindShort.self": "Self",
  "performance.review.kindShort.manager": "Manager",
  "performance.review.kindShort.peer": "Peers",
  "performance.review.kindShort.upward": "Upward",
  "performance.review.anonymous": "Anonymous",
  "performance.growth.title": "Growth",
  "performance.growth.nav.label": "Growth sections",
  "performance.growth.nav.reviews": "Reviews",
  "performance.growth.nav.goals": "Goals",
  "performance.growth.nav.meetings": "One-to-ones",
  "performance.growth.nav.feedback": "Feedback",
  "performance.growth.nav.team": "My team",
  "performance.reviews.toWrite": "Reviews to write",
  "performance.reviews.toWriteHint": "Your self review and the reviews you write for colleagues, by cycle. Drafts save as you type.",
  "performance.reviews.loadError": "We couldn’t load your reviews",
  "performance.reviews.empty.title": "No reviews to write",
  "performance.reviews.empty.body": "When HR launches a review cycle, the reviews you’re asked to write show up here.",
  "performance.reviews.due": "Due {date}",
  "performance.reviews.openCount": "{count, plural, one {# to write} other {# to write}}",
  "performance.reviews.allDone": "All done",
  "performance.reviews.writingClosed": "Writing closed",
  "performance.reviews.yourSelfReview": "Your self review",
  "performance.form.documentTitle": "Write a review",
  "performance.form.back": "All reviews",
  "performance.form.loadError": "We couldn’t load this review",
  "performance.form.title.self": "Your self review",
  "performance.form.title.manager": "Your review of {name}",
  "performance.form.title.peer": "Peer review of {name}",
  "performance.form.title.upward": "Upward review of {name}",
  "performance.form.about.self": "Look back on your own work this period. Your manager and HR read it once you submit.",
  "performance.form.about.manager": "Your ratings make {name}’s result. They read your review once HR publishes the results.",
  "performance.form.about.peer": "{name} sees peers’ answers without names: an average and the comments. Their manager and HR see who wrote what.",
  "performance.form.about.upward": "Tell {name} how they manage you: what helps, and what could be better.",
  "performance.upward.title": "Your answers stay anonymous",
  "performance.upward.promise": "{name} never sees your name. They only see averages and comments once at least 3 people who report to them have answered.",
  "performance.form.required": "Required",
  "performance.form.optional": "Optional",
  "performance.form.rateThis": "Choose a rating for this question.",
  "performance.form.comment": "Comment (optional)",
  "performance.form.commentPlaceholder": "An example helps the most.",
  "performance.form.answer": "Your answer",
  "performance.form.answerPlaceholder": "Write your answer…",
  "performance.form.answered": "{done} of {total} answered",
  "performance.form.submit": "Submit review",
  "performance.form.submitting": "Submitting…",
  "performance.form.submitTitle": "Submit this review?",
  "performance.form.submitBody.self": "Your answers can’t change after you submit. Your manager and HR will read them.",
  "performance.form.submitBody.manager": "Your answers can’t change after you submit. {name} reads them once results are published.",
  "performance.form.submitBody.peer": "Your answers can’t change after you submit. {name} sees them without your name.",
  "performance.form.submitBody.upward": "Your answers can’t change after you submit. They stay anonymous.",
  "performance.form.submitted": "Review submitted. Thank you!",
  "performance.form.incompleteTitle": "Some questions still need a rating",
  "performance.form.incompleteBody": "{count, plural, one {Rate the question marked below, then submit again.} other {Rate the # questions marked below, then submit again.}}",
  "performance.form.conflictTitle": "This review changed somewhere else",
  "performance.form.conflictBody": "It was saved in another tab or window. Reload to carry on from the latest answers.",
  "performance.form.reload": "Reload",
  "performance.form.decline": "Decline",
  "performance.form.declineTitle": "Decline this review?",
  "performance.form.declineBody": "Say why you can’t review {name}, for example that you didn’t work together this period. HR sees your reason.",
  "performance.form.declined": "Review declined.",
  "performance.form.closed.submittedTitle": "Submitted",
  "performance.form.closed.submitted": "You submitted this review on {date}.",
  "performance.form.closed.declinedTitle": "You declined this review",
  "performance.form.closed.writingTitle": "Writing is closed",
  "performance.form.closed.writing": "This cycle no longer takes reviews. Ask HR if you still need to submit.",
  "performance.results.mine": "Your results",
  "performance.results.mineHint": "Published results from the cycles you were reviewed in.",
  "performance.results.loadError": "We couldn’t load the results",
  "performance.results.empty.title": "No results yet",
  "performance.results.empty.body": "Once HR publishes a cycle you were reviewed in, your results show up here.",
  "performance.results.acknowledged": "Acknowledged",
  "performance.results.toAcknowledge": "Read and acknowledge",
  "performance.results.documentTitle": "Review results",
  "performance.results.yours": "Your results",
  "performance.results.theirs": "{name}’s results",
  "performance.results.manager": "Manager: {name}",
  "performance.results.finalRating": "Final result",
  "performance.results.noFinal": "No final rating yet",
  "performance.results.acknowledge": "I’ve read my review",
  "performance.results.acknowledgeHint": "Please read your review, then confirm you’ve read it. Acknowledging doesn’t mean you agree.",
  "performance.results.acknowledgedToast": "Thanks for reading your review.",
  "performance.results.acknowledgedOn": "Acknowledged on {date}",
  "performance.results.notAcknowledged": "Not acknowledged yet.",
  "performance.results.notPublished": "Results aren’t published yet, so the person can’t read them.",
  "performance.results.comparison": "Self and manager reviews",
  "performance.results.comparisonHint": "Question by question, side by side.",
  "performance.results.notSubmitted": "Not submitted",
  "performance.results.noAnswer": "No answer",
  "performance.results.noReviews.title": "No reviews submitted yet",
  "performance.results.noReviews.body": "The self and manager reviews show here once they’re submitted.",
  "performance.results.peers": "What peers said",
  "performance.results.peersHint": "Without names: the average rating and every comment, per question.",
  "performance.results.peersNamedHint": "Each peer’s review with its writer. The person sees these only as anonymous averages.",
  "performance.results.average": "Average",
  "performance.results.answer": "Answer",
  "performance.upward.sectionTitle": "Upward feedback",
  "performance.upward.sectionHint": "What the people who report to this manager said, never who said it.",
  "performance.upward.notEnoughTitle": "Not enough answers yet",
  "performance.upward.waiting": "{done} of {total} answers so far. Answers show only once at least {total} people have answered, so none can be traced to one person.",
  "performance.upward.visible": "Answered by {done} people. Shown as averages and comments only.",
  "performance.goals.title": "Goals",
  "performance.goals.hint": "What you’re aiming for this period, measured by key results. Update progress as you go.",
  "performance.goals.viewLabel": "Whose goals",
  "performance.goals.view.mine": "My goals",
  "performance.goals.view.company": "Company goals",
  "performance.goals.new": "New goal",
  "performance.goals.newCompany": "New company goal",
  "performance.goals.loadError": "We couldn’t load the goals",
  "performance.goals.empty.title": "No goals yet",
  "performance.goals.empty.body": "Set a goal for this period and add key results to measure it.",
  "performance.goals.companyEmpty.title": "No company goals yet",
  "performance.goals.companyEmpty.body": "When HR sets the agency’s goals, you’ll see them here with the goals that support them.",
  "performance.goals.treeHint": "The agency’s goals, with your goals under the ones they support.",
  "performance.goals.treeLabel": "Goal alignment",
  "performance.goals.company": "Company",
  "performance.goals.finished": "Done or dropped",
  "performance.goals.noKeyResults": "No key results: progress is set by hand.",
  "performance.goals.checkIn": "Update progress",
  "performance.goals.edit": "Edit goal",
  "performance.goals.back": "All goals",
  "performance.goals.progressLabel": "{percent} complete",
  "performance.goals.progressOf": "{title}: {percent} complete",
  "performance.goals.krValue": "{number} / {total} {label}",
  "performance.goals.krProgress": "{title}: {percent}",
  "performance.goals.krRange": "From {start} to {end} {label}",
  "performance.goals.supports": "Supports",
  "performance.goals.supportedBy": "Supported by",
  "performance.goals.supportedByHint": "Goals that roll up into this one.",
  "performance.goals.created": "Goal added.",
  "performance.goals.saved": "Goal saved.",
  "performance.goals.checkedIn": "Progress updated.",
  "performance.goals.checkInTitle": "Update progress",
  "performance.goals.checkInSave": "Save update",
  "performance.goals.checkInNote": "What changed? (optional)",
  "performance.goals.checkInNotePlaceholder": "A win, a blocker, what’s next…",
  "performance.goals.checkInInvalid": "Enter a number for each key result (and a progress from 0 to 100).",
  "performance.goals.previewHint": "Progress is the average of the key results, each from its start to its target.",
  "performance.goals.status.on_track": "On track",
  "performance.goals.status.at_risk": "At risk",
  "performance.goals.status.off_track": "Off track",
  "performance.goals.status.done": "Done",
  "performance.goals.status.dropped": "Dropped",
  "performance.goals.visibility.public": "Public",
  "performance.goals.visibility.private": "Private",
  "performance.goals.visibilityHint.public": "Everyone on the team can see it.",
  "performance.goals.visibilityHint.private": "Only you, your manager and HR.",
  "performance.goals.history.title": "Progress updates",
  "performance.goals.history.empty.title": "No updates yet",
  "performance.goals.history.empty.body": "Each progress update shows here with its note.",
  "performance.goals.history.progress": "{percent} complete",
  "performance.goals.form.newTitle": "New goal",
  "performance.goals.form.editTitle": "Edit goal",
  "performance.goals.form.hint": "Make it specific, and measure it with key results.",
  "performance.goals.form.companyHint": "A goal for the whole agency. Everyone can align their goals under it.",
  "performance.goals.form.title": "Goal",
  "performance.goals.form.titleRequired": "Write the goal.",
  "performance.goals.form.description": "Why it matters (optional)",
  "performance.goals.form.startsOn": "Starts",
  "performance.goals.form.endsOn": "Ends",
  "performance.goals.form.parent": "Supports",
  "performance.goals.form.parentHint": "Link it to a company goal or one of your own goals.",
  "performance.goals.form.parentNone": "Not linked",
  "performance.goals.form.parentSearch": "Search goals",
  "performance.goals.form.parentEmpty": "No goals match.",
  "performance.goals.form.visibility": "Who can see it",
  "performance.goals.form.status": "Status",
  "performance.goals.form.progress": "Progress (%)",
  "performance.goals.form.progressHint": "Used while the goal has no key results.",
  "performance.goals.form.progressRange": "Enter a number from 0 to 100.",
  "performance.goals.form.keyResults": "Key results",
  "performance.goals.form.keyResultsHint": "How you’ll know you got there: a start value, a target and where it stands now.",
  "performance.goals.form.keyResultNumber": "Key result {number}",
  "performance.goals.form.krTitle": "Key result {number}",
  "performance.goals.form.start": "Start",
  "performance.goals.form.target": "Target",
  "performance.goals.form.current": "Now",
  "performance.goals.form.unit": "Unit",
  "performance.goals.form.krPreview": "Progress: {percent}",
  "performance.goals.form.krIncomplete": "Enter the numbers to see its progress.",
  "performance.goals.form.removeKr": "Remove key result {number}",
  "performance.goals.form.addKr": "Add key result",
  "performance.goals.form.create": "Add goal",
  "performance.goals.form.save": "Save goal",
  "performance.meetings.title": "One-to-ones",
  "performance.meetings.hint": "Regular time with your manager or your reports: a shared agenda, agreed actions and notes.",
  "performance.meetings.schedule": "Schedule",
  "performance.meetings.loadError": "We couldn’t load your one-to-ones",
  "performance.meetings.empty.title": "No one-to-ones yet",
  "performance.meetings.empty.body": "Schedule one with your manager or one of your reports.",
  "performance.meetings.empty.noTeam": "One-to-ones are between a manager and their report. Once your record names a manager or reports, you can schedule one.",
  "performance.meetings.upcoming": "Upcoming",
  "performance.meetings.past": "Earlier",
  "performance.meetings.with": "One-to-one with {name}",
  "performance.meetings.relation.manager": "Your manager",
  "performance.meetings.relation.report": "Reports to you",
  "performance.meetings.back": "All one-to-ones",
  "performance.meetings.scheduleTitle": "Schedule a one-to-one",
  "performance.meetings.scheduleHint": "With your manager or someone who reports to you.",
  "performance.meetings.withLabel": "With",
  "performance.meetings.option.manager": "{name} (your manager)",
  "performance.meetings.option.report": "{name} (reports to you)",
  "performance.meetings.whenLabel": "Date and time",
  "performance.meetings.whenRequired": "Pick a date and time.",
  "performance.meetings.scheduled": "One-to-one scheduled.",
  "performance.meetings.status.scheduled": "Scheduled",
  "performance.meetings.status.done": "Held",
  "performance.meetings.status.cancelled": "Cancelled",
  "performance.meeting.agenda": "Talking points",
  "performance.meeting.agendaHint": "Either of you can add what you want to talk about.",
  "performance.meeting.noPoints": "No talking points yet.",
  "performance.meeting.newPoint": "Add a talking point",
  "performance.meeting.actions": "Agreed actions",
  "performance.meeting.actionsHint": "Who does what next. Open actions carry over to your next one-to-one.",
  "performance.meeting.noActions": "No actions yet.",
  "performance.meeting.newAction": "Add an action",
  "performance.meeting.assignee": "Who does it",
  "performance.meeting.noAssignee": "No one yet",
  "performance.meeting.add": "Add",
  "performance.meeting.addedBy": "Added by {name}",
  "performance.meeting.assignedTo": "{name}",
  "performance.meeting.remove": "Remove “{title}”",
  "performance.meeting.carried": "Still open from earlier one-to-ones",
  "performance.meeting.sharedNotes": "Shared notes",
  "performance.meeting.sharedHint": "You and {name} both see these notes.",
  "performance.meeting.sharedPlaceholder": "Notes from your conversation…",
  "performance.meeting.conflictTitle": "The notes changed",
  "performance.meeting.conflictBody": "{name} saved the shared notes at the same time. Copy anything you want to keep, then reload to see their changes.",
  "performance.meeting.privateNotes": "Private notes",
  "performance.meeting.privateHint": "Only you can see this. {name} never will, and neither will HR.",
  "performance.meeting.privatePlaceholder": "Your own notes for this meeting…",
  "performance.meeting.privateUpdated": "Last saved {date}",
  "performance.meeting.markDone": "Mark as held",
  "performance.meeting.markedDone": "Marked as held.",
  "performance.meeting.reschedule": "Reschedule",
  "performance.meeting.rescheduleTitle": "Move this one-to-one",
  "performance.meeting.rescheduled": "One-to-one moved.",
  "performance.meeting.cancel": "Cancel meeting",
  "performance.meeting.cancelTitle": "Cancel this one-to-one?",
  "performance.meeting.cancelBody": "Its talking points, actions and notes stay. You can reopen it later.",
  "performance.meeting.cancelConfirm": "Cancel meeting",
  "performance.meeting.reopen": "Reopen",
  "performance.meeting.reopened": "One-to-one reopened.",
  "performance.feedback.title": "Feedback",
  "performance.feedback.hint": "Praise colleagues for everyone to see, send private feedback, or ask for someone’s view.",
  "performance.feedback.give": "Give feedback",
  "performance.feedback.ask": "Ask for feedback",
  "performance.feedback.viewLabel": "Which feedback",
  "performance.feedback.view.received": "Received",
  "performance.feedback.view.given": "Given",
  "performance.feedback.view.wall": "Praise wall",
  "performance.feedback.view.requests": "Requests",
  "performance.feedback.loadError": "We couldn’t load the feedback",
  "performance.feedback.empty.received.title": "No feedback yet",
  "performance.feedback.empty.received.body": "Praise and private feedback from colleagues show here.",
  "performance.feedback.empty.given.title": "You haven’t given feedback yet",
  "performance.feedback.empty.given.body": "A few words of praise go a long way.",
  "performance.feedback.empty.wall.title": "The praise wall is empty",
  "performance.feedback.empty.wall.body": "Be the first to praise a colleague for everyone to see.",
  "performance.feedback.to": "to",
  "performance.feedback.kind.praise": "Praise",
  "performance.feedback.kind.private": "Private",
  "performance.feedback.kind.requested": "Requested",
  "performance.feedback.kindLabel": "Kind",
  "performance.feedback.kindHint.praise": "On the team praise wall: everyone sees it.",
  "performance.feedback.kindHint.private": "Only them, their manager and HR read it.",
  "performance.feedback.giveTitle": "Give feedback",
  "performance.feedback.giveHint": "Be specific: what they did and why it mattered.",
  "performance.feedback.recipient": "To",
  "performance.feedback.recipientPlaceholder": "Choose a colleague",
  "performance.feedback.recipientRequired": "Choose who it’s for.",
  "performance.feedback.body": "Message",
  "performance.feedback.bodyRequired": "Write a message.",
  "performance.feedback.value": "Company value (optional)",
  "performance.feedback.valueHint": "A value this shows, such as “Ownership”.",
  "performance.feedback.send": "Send",
  "performance.feedback.sent.praise": "Praise posted on the wall.",
  "performance.feedback.sent.private": "Private feedback sent.",
  "performance.feedback.askTitle": "Ask for feedback",
  "performance.feedback.askHint": "Ask colleagues about yourself or, as a manager, about someone who reports to you.",
  "performance.feedback.subject": "About",
  "performance.feedback.aboutMe": "Me",
  "performance.feedback.reviewers": "Who to ask",
  "performance.feedback.reviewersPlaceholder": "Choose colleagues",
  "performance.feedback.reviewersFull": "{count, plural, other {You can choose up to # people.}}",
  "performance.feedback.question": "Your question",
  "performance.feedback.questionPlaceholder": "For example: what should I keep doing, and what should I change?",
  "performance.feedback.questionRequired": "Write a question of at least {min} characters.",
  "performance.feedback.dueOn": "Answer by (optional)",
  "performance.feedback.requested": "{count, plural, one {Request sent.} other {# requests sent.}}",
  "performance.feedback.requestsLoadError": "We couldn’t load the requests",
  "performance.feedback.requestsEmpty.title": "No requests",
  "performance.feedback.requestsEmpty.body": "Requests you make, and the ones waiting for your answer, show here.",
  "performance.feedback.waitingForYou": "Waiting for your answer",
  "performance.feedback.nothingWaiting": "Nothing waiting for you.",
  "performance.feedback.youAsked": "You asked",
  "performance.feedback.askedYouAbout": "Asks you about {name}",
  "performance.feedback.askedAbout": "Asked about {name}",
  "performance.feedback.requestStatus.open": "Waiting",
  "performance.feedback.requestStatus.answered": "Answered",
  "performance.feedback.requestStatus.declined": "Declined",
  "performance.feedback.answer": "Answer",
  "performance.feedback.decline": "Decline",
  "performance.feedback.answerTitle": "Feedback about {name}",
  "performance.feedback.answerHint": "{name} reads your answer, and so does {actor}, who asked.",
  "performance.feedback.yourAnswer": "Your answer",
  "performance.feedback.answered": "Thanks, your feedback was sent.",
  "performance.feedback.declineTitle": "Decline this request?",
  "performance.feedback.declineBody": "{name} sees that you declined.",
  "performance.feedback.declined": "Request declined.",
  "performance.team.cycles": "Your team’s reviews",
  "performance.team.cyclesHint": "How far each report’s reviews got in every cycle, and their results.",
  "performance.team.loadError": "We couldn’t load your team’s cycles",
  "performance.team.cycleError": "This cycle didn’t load. Try again shortly.",
  "performance.team.noCycles.title": "No review cycles for your team",
  "performance.team.noCycles.body": "When HR launches a cycle your reports are in, it shows here.",
  "performance.team.goals": "Team goals",
  "performance.team.goalsHint": "Your reports’ goals and their progress.",
  "performance.team.noGoals.title": "No team goals yet",
  "performance.team.noGoals.body": "Goals your reports set show here.",
  "performance.team.openResults": "Results",
  "performance.team.resultsOf": "of {name}",
  "performance.team.back": "My team",
  "performance.hub.nav": "Performance sections",
  "performance.hub.cycles": "Review cycles",
  "performance.hub.templates": "Templates",
  "performance.cycles.title": "Review cycles",
  "performance.cycles.hint": "Each cycle asks for self, manager, peer and upward reviews on one template, then goes through calibration before results are published.",
  "performance.cycles.new": "New cycle",
  "performance.cycles.loadError": "We couldn’t load the review cycles",
  "performance.cycles.empty.title": "No review cycles yet",
  "performance.cycles.empty.body": "Create a cycle, add the people to review, then launch it.",
  "performance.cycles.column.name": "Cycle",
  "performance.cycles.column.period": "Period",
  "performance.cycles.column.includes": "Reviews",
  "performance.cycles.column.status": "Status",
  "performance.cycles.back": "All cycles",
  "performance.cycles.edit": "Edit details",
  "performance.cycles.newTitle": "New review cycle",
  "performance.cycles.editTitle": "Edit cycle",
  "performance.cycles.formHint": "It starts as a draft: nothing is sent until you launch it.",
  "performance.cycles.create": "Create cycle",
  "performance.cycles.save": "Save",
  "performance.cycles.created": "Cycle created. Add the people to review.",
  "performance.cycles.saved": "Cycle saved.",
  "performance.cycles.noTemplates": "There’s no active template yet. Create one in Templates first.",
  "performance.cycles.form.name": "Name",
  "performance.cycles.form.namePlaceholder": "For example: Q4 2026 reviews",
  "performance.cycles.form.nameRequired": "Name the cycle.",
  "performance.cycles.form.template": "Template",
  "performance.cycles.form.templatePlaceholder": "Choose a template",
  "performance.cycles.form.templateRequired": "Choose a template.",
  "performance.cycles.form.templateLocked": "The template can’t change once the cycle is launched.",
  "performance.cycles.form.periodStart": "Period starts",
  "performance.cycles.form.periodEnd": "Period ends",
  "performance.cycles.form.reviewDue": "Reviews due",
  "performance.cycles.form.dateRequired": "Pick a date.",
  "performance.cycles.form.dueAfterStart": "Reviews fall due on or after the period starts.",
  "performance.cycles.form.includes": "Reviews to ask for",
  "performance.cycles.form.managerAlways": "Every person’s manager always reviews them.",
  "performance.cycles.form.includesLocked": "The reviews were created when the cycle launched, so who reviews whom can’t change now.",
  "performance.cycles.form.includeSelf": "Self review",
  "performance.cycles.form.includeSelfHint": "Each person reviews their own work.",
  "performance.cycles.form.includePeer": "Peer reviews",
  "performance.cycles.form.includePeerHint": "Colleagues chosen for each person review them; the person sees their answers without names.",
  "performance.cycles.form.includeUpward": "Upward reviews",
  "performance.cycles.form.includeUpwardHint": "Reports review their manager anonymously; the manager sees only averages once 3 have answered.",
  "performance.stepper.title": "Cycle progress",
  "performance.stepper.state.done": "(done)",
  "performance.stepper.state.current": "(current step)",
  "performance.stepper.state.upcoming": "(to come)",
  "performance.stepper.explain.draft": "Add the people to review and their peers, then launch. Launching opens every review and notifies each reviewer.",
  "performance.stepper.explain.active": "Reviews are being written. Once they’re in, close writing to calibrate the ratings.",
  "performance.stepper.explain.calibration": "Writing is closed. Even out the ratings, then publish. You can reopen writing for a late reviewer.",
  "performance.stepper.explain.published": "People can read their results and acknowledge them. Close the cycle when you’re done.",
  "performance.stepper.explain.closed": "This cycle is closed. Its results stay readable.",
  "performance.stepper.needPeople": "Add at least one person first.",
  "performance.stepper.action.launch": "Launch cycle",
  "performance.stepper.action.calibrate": "Close writing and calibrate",
  "performance.stepper.action.reopen": "Reopen writing",
  "performance.stepper.action.publish": "Publish results",
  "performance.stepper.action.close": "Close cycle",
  "performance.stepper.confirm.launch.title": "Launch this cycle?",
  "performance.stepper.confirm.launch.body": "Reviews open for {count, plural, one {# person} other {# people}} and every reviewer gets a notification. The people and the template can’t change after launch.",
  "performance.stepper.confirm.calibrate.title": "Close writing?",
  "performance.stepper.confirm.calibrate.body": "Reviewers can no longer submit. Reviews still pending stay unwritten unless you reopen writing.",
  "performance.stepper.confirm.reopen.title": "Reopen writing?",
  "performance.stepper.confirm.reopen.body": "Reviewers can submit again until you close writing. Calibrated ratings are kept.",
  "performance.stepper.confirm.publish.title": "Publish the results?",
  "performance.stepper.confirm.publish.body": "Each person can then read their manager’s review, their peers’ answers without names and their final result, and is asked to acknowledge it. This can’t be undone.",
  "performance.stepper.confirm.close.title": "Close this cycle?",
  "performance.stepper.confirm.close.body": "The cycle moves to closed. Results stay readable; nothing else changes.",
  "performance.stepper.done.launch": "Cycle launched. Reviewers have been notified.",
  "performance.stepper.done.calibrate": "Writing closed. Calibration can start.",
  "performance.stepper.done.reopen": "Writing reopened.",
  "performance.stepper.done.publish": "Results published.",
  "performance.stepper.done.close": "Cycle closed.",
  "performance.participants.title": "People in this cycle",
  "performance.participants.hint": "Choose who is reviewed. Their manager comes from their HR record at launch.",
  "performance.participants.hintPeers": "Choose who is reviewed and the peers who review each one. Their manager comes from their HR record at launch.",
  "performance.participants.add": "Add people",
  "performance.participants.addPlaceholder": "Choose people to review",
  "performance.participants.addChosen": "{count, plural, =0 {Add} one {Add # person} other {Add # people}}",
  "performance.participants.addEveryone": "{count, plural, =0 {Everyone is in} other {Add everyone (#)}}",
  "performance.participants.saved": "People saved.",
  "performance.participants.empty.title": "No one in this cycle yet",
  "performance.participants.empty.body": "Add the people to review above, or everyone at once.",
  "performance.participants.noManager": "No manager on record",
  "performance.participants.noPeers": "No peers yet",
  "performance.participants.peers": "{count, plural, =0 {Choose peers} one {# peer} other {# peers}}",
  "performance.participants.remove": "Remove {name} from the cycle",
  "performance.peers.title": "Peers for {name}",
  "performance.peers.hint": "Up to ten colleagues who know their work. Their review requests go out at launch.",
  "performance.peers.liveHint": "New peers are asked right away. Peers who already submitted stay; removing a peer drops only a review not yet written.",
  "performance.peers.label": "Peers",
  "performance.peers.placeholder": "Choose colleagues",
  "performance.peers.save": "Save peers",
  "performance.peers.saved": "Peers saved.",
  "performance.progress.title": "Review progress",
  "performance.progress.hint": "Who has submitted, who hasn’t, and who declined. Upward reviews show only as a count.",
  "performance.progress.caption": "Review progress per person",
  "performance.progress.person": "Person",
  "performance.progress.reviews": "Reviews",
  "performance.progress.count": "{done} of {total}",
  "performance.progress.manager": "Manager rating",
  "performance.progress.final": "Final result",
  "performance.progress.acknowledged": "Acknowledged",
  "performance.progress.notYet": "Not yet",
  "performance.progress.actions": "Actions",
  "performance.progress.peers": "Peers",
  "performance.progress.none": "No reviews",
  "performance.progress.reviewer": "{name} · {label}",
  "performance.progress.iconLabel": "{label}: {status}",
  "performance.progress.upward": "Upward: {done} of {total} submitted",
  "performance.calibration.title": "Calibration",
  "performance.calibration.hint": "Even out ratings across the team. Drag a person to another rating or use “Change rating”. A note is required whenever the result differs from the manager’s rating.",
  "performance.calibration.distribution": "Rating distribution",
  "performance.calibration.viewLabel": "Show as",
  "performance.calibration.chart": "Chart",
  "performance.calibration.table": "Table",
  "performance.calibration.barTooltip": "{label}: {count, plural, one {# person} other {# people}}",
  "performance.calibration.rating": "Rating",
  "performance.calibration.people": "People",
  "performance.calibration.emptyBucket": "Drop someone here",
  "performance.calibration.unrated": "No rating yet",
  "performance.calibration.unratedHint": "Their manager hasn’t submitted a review. Set a result, or reopen writing.",
  "performance.calibration.calibrated": "Calibrated",
  "performance.calibration.change": "Change rating",
  "performance.calibration.dragHandle": "Move {name} to another rating",
  "performance.calibration.picked": "Picked up {name}.",
  "performance.calibration.over": "{name} is over “{label}”.",
  "performance.calibration.dropped": "{name} dropped on “{label}”.",
  "performance.calibration.cancelled": "Moving {name} was cancelled.",
  "performance.calibration.dialogTitle": "Calibrate {name}",
  "performance.calibration.dialogHint": "The result you set becomes their final rating.",
  "performance.calibration.final": "Final",
  "performance.calibration.newRating": "Result",
  "performance.calibration.noteRequired": "Why it differs (required)",
  "performance.calibration.noteOptional": "Note (optional)",
  "performance.calibration.noteHint": "A note is required when the result differs from the manager’s rating ({number}).",
  "performance.calibration.noManagerRating": "There’s no manager rating yet, so say why you set this result.",
  "performance.calibration.reset": "Reset to manager’s rating",
  "performance.calibration.save": "Save result",
  "performance.calibration.saved": "Result saved for {name}.",
  "performance.calibration.resetDone": "{name} is back on the manager’s rating.",
  "performance.templates.title": "Review templates",
  "performance.templates.hint": "The questions a cycle asks, and who is asked each one. A template in use by a cycle under way can’t change its questions.",
  "performance.templates.new": "New template",
  "performance.templates.loadError": "We couldn’t load the templates",
  "performance.templates.empty.title": "No templates yet",
  "performance.templates.empty.body": "Write the questions your reviews ask, in Arabic and English.",
  "performance.templates.inactive": "Switched off",
  "performance.templates.inUse": "In use: questions locked",
  "performance.templates.questionCount": "{count, plural, one {# question} other {# questions}}",
  "performance.templates.edit": "Edit",
  "performance.templates.newTitle": "New template",
  "performance.templates.editTitle": "Edit template",
  "performance.templates.formHint": "Rating questions use a 1–5 scale with an optional comment; text questions take a written answer.",
  "performance.templates.name": "Name",
  "performance.templates.nameRequired": "Name the template.",
  "performance.templates.description": "Description (optional)",
  "performance.templates.active": "Active",
  "performance.templates.activeHint": "Offered when creating a new cycle.",
  "performance.templates.lockedTitle": "Questions are locked",
  "performance.templates.lockedBody": "A cycle under way uses this template, so its questions can’t change. You can still rename it or switch it off.",
  "performance.templates.questions": "Questions",
  "performance.templates.questionNumber": "Question {number}",
  "performance.templates.moveUp": "Move question {number} up",
  "performance.templates.moveDown": "Move question {number} down",
  "performance.templates.remove": "Remove question {number}",
  "performance.templates.promptAr": "Question in Arabic",
  "performance.templates.promptEn": "Question in English",
  "performance.templates.kind": "Kind",
  "performance.templates.kinds.rating": "Rating (1–5)",
  "performance.templates.kinds.text": "Written answer",
  "performance.templates.weight": "Weight",
  "performance.templates.competency": "Competency (optional)",
  "performance.templates.required": "Required",
  "performance.templates.askedOf": "Asked in:",
  "performance.templates.audience.forSelf": "Self",
  "performance.templates.audience.forManager": "Manager",
  "performance.templates.audience.forPeer": "Peers",
  "performance.templates.audience.forUpward": "Upward",
  "performance.templates.addQuestion": "Add question",
  "performance.templates.fixErrors": "Fill in both prompts, a weight above 0 (up to 10), and at least one review for every question.",
  "performance.templates.save": "Save template",
  "performance.templates.created": "Template created.",
  "performance.templates.saved": "Template saved.",
  "performance.errors.templateNotFound": "That template no longer exists.",
  "performance.errors.templateInUse": "A cycle under way uses this template, so its questions can’t change.",
  "performance.errors.cycleNotFound": "That review cycle no longer exists.",
  "performance.errors.cycleState": "That step doesn’t apply to the cycle right now. Reload to see where it stands.",
  "performance.errors.participantNotFound": "We couldn’t find that person’s review.",
  "performance.errors.reviewNotFound": "That review no longer exists.",
  "performance.errors.reviewClosed": "This review was already submitted or declined, or its cycle moved on.",
  "performance.errors.answersIncomplete": "Rate every required question before submitting.",
  "performance.errors.goalNotFound": "That goal no longer exists, or you can’t change it.",
  "performance.errors.goalLoop": "A goal can’t support itself or one of its own sub-goals.",
  "performance.errors.meetingNotFound": "That one-to-one no longer exists.",
  "performance.errors.feedbackNotFound": "That request was already answered or declined.",
  "performance.errors.feedbackToSelf": "Feedback goes to someone else.",
  "performance.errors.noParticipants": "Add the people to review before launching.",
  "performance.errors.needsRecord": "Everyone in a cycle needs an HR record.",
  "performance.errors.cycleDates": "The period ends after it starts.",
  "performance.errors.goalDates": "The goal ends after it starts.",
  "performance.errors.noteRequired": "Say why the result differs from the manager’s rating.",
  "performance.errors.notManagerPair": "One-to-ones are between a manager and someone who reports to them.",
  "performance.errors.subjectNotReport": "Ask about yourself, or about someone who reports to you.",
  "performance.errors.noReviewers": "Choose at least one colleague to ask.",
  "performance.errors.recipient": "Choose someone on the team.",
  "performance.errors.gone": "It may have been removed, or it isn’t shared with you."
}
